//@ts-nocheck
import Swiper, { Navigation, Pagination } from 'swiper';
import { optionSelect } from '../components/trivia/optionSelect';


window.onload = function() { 
	fillSelectOptions()
	consultingWinners();
	consultingSelectOptions()
	btnsPaginadores()
};

window.addEventListener("load", function () {
  	mySwiperProducts()
	datalayers();
	dalayerBuy()

});

function cleancontainer(container:any) {
	while (container?.firstChild) {
		container.removeChild(container.firstChild)
	}
}

const registroPorPagina = 10;
let totalPaginas:number;
let iterador;
let paginaActual = 1;
const paginadorGanadores = document.querySelector('#paginadorGanadores')
const paginadorWinners = (total:number) => {
	return parseInt(Math.ceil(total / registroPorPagina))
}

function fillSelectOptions() {
	const filterTeam = document.querySelector('#filterTeam')
	// const url = 'http://localhost:4200/equipos';
	const url = '/get/teams';
	fetch(url)
		.then(consulta => consulta.json())
		.then(equipos => {
			// Limpiar paginador previo
			cleancontainer(filterTeam)
			// while (filterTeam?.firstChild) {
			// 	filterTeam.removeChild(filterTeam.firstChild)
			// }
			const options2 = document.createElement('OPTION')
			options2.value = ''
			options2.textContent = 'Seleccione un equipo';
			filterTeam?.appendChild(options2)
			equipos.map( (equipo:string, index:any) => {
				const options = document.createElement('OPTION')
				options.value = equipo.name
				options.textContent = equipo.name;
				filterTeam?.appendChild(options)
			})
		})

}
function consultingSelectOptions() {
	const filterTeam = document.querySelector('#filterTeam')
	filterTeam?.addEventListener('change', teamSelected => {
		cleancontainer(document.querySelector('.tablaGanadores__usuarios'));
		paginaActual = 1;
		if(filterTeam.value === '') {
			consultingWinners('', paginaActual)
		} else {
			consultingWinners(filterTeam.value)
		}
	})
}

function addActiveButon(num:number) {
	const allbtns = [...document.querySelectorAll('.btnPaginador')];
	allbtns.map(e => {
		if(Number(e.textContent) === num) {
			e.classList.add('active')
		} else {
			e.classList.remove('active')
		}
	})
	
}

// Generador
function *crearPaginador(total) {
	for(let i = 1; i <= total; i++) {
		yield i;
	}
}
function printPaginator() {
	iterador = crearPaginador(totalPaginas);
	while (true) {
		const { value, done } = iterador.next();
		if(done) return;
		const boton = document.createElement('a')
		boton.href = '#'
		boton.dataset.pagina = value;
		boton.textContent = value;
		boton.classList.add('siguiente', 'btnPaginador')

		boton.onclick = btn => {
			btn.preventDefault()
			paginaActual = value;
			[...document.querySelectorAll('#paginadorGanadores a')].map( (e:any) => e.classList.contains('active') && e.classList.remove('active'))
			boton.classList.add('active')
		}

		paginadorGanadores?.appendChild(boton);
	}
}
function printPaginatorTotal(num) {
	const limitPaginator = document.createElement('P');
	const allbtns = [...document.querySelectorAll('.btnPaginador')].length;
	limitPaginator.classList.add('limirPaginator');

	const text = document.createTextNode(`de ${allbtns}`);
	limitPaginator.appendChild(text);

	paginadorGanadores?.appendChild(limitPaginator);
}

// Btns paginador
function btnsPaginadores() {
	const btnsPaginador = [...document.querySelectorAll('.btndPagiGeneral')]
	btnsPaginador.map( (btnCliked:any) => {
		btnCliked.addEventListener('click', (btn:any) => {
			btn.preventDefault()
			const selectFilter = document.querySelector('#filterTeam')?.value;
			if(btnCliked.classList.contains('prev')) {
				paginaActual = paginaActual - 1
				// paginaActual > 0 ? consultingWinners('', paginaActual) : paginaActual = 1;
				if(paginaActual > 0 && selectFilter === '') {
					consultingWinners('', paginaActual)
				} 
				else if(paginaActual > 0 && selectFilter !== '') {
					consultingWinners(selectFilter, paginaActual)
				} 
				else {
					paginaActual = 1
				}
			} else if(btnCliked.classList.contains('next')) {
				paginaActual = paginaActual + 1
				// console.log(paginaActual);
				
				const totalPages = [...document.querySelectorAll('.btnPaginador')].length;
				// paginaActual <= totalPages ? consultingWinners('', paginaActual) : paginaActual = totalPages;
				if(paginaActual <= totalPages && selectFilter === '') {
					consultingWinners('', paginaActual)
				} 
				else if(paginaActual <= totalPages && selectFilter !== '') {
					consultingWinners(selectFilter, paginaActual)
				} 
				else {
					paginaActual = totalPages
				}
			}
			
		})
		
	})


}

const consultingWinners = async (teamSelect:string = '', pagina:number = 1) => {
	const tablaGanadores = document.querySelector('.tablaGanadores .tablaGanadores__usuarios')
	// const url = `http://localhost:4000/${pagina}`;
	const url = teamSelect === '' ? `/get/winners?pagination=10&page=${pagina}` : `/get/winners?pagination=10&page=${pagina}&equipo=${teamSelect}`;
	try {
		const respuesta = await fetch(url)
		const resultado = await respuesta.json()
		// console.log(resultado.data);
		let arrayConsulta = resultado.data;
		// totalPaginas = paginadorWinners(resultado.length);
		totalPaginas = paginadorWinners(resultado.pagination.total_items)
		
		// totalPaginas = 5;
		
		cleancontainer(tablaGanadores)
		if(teamSelect === "") {
			// totalPaginas = 5;
			// Crando contenedor de usuario
			arrayConsulta.map( (usuario:any) => {
				const userContainer = document.createElement('DIV');
				userContainer.classList.add('tablaGanadores__containerUser');

				const nameParagraph = document.createElement('P');
				nameParagraph.classList.add('name');
				const nameText = document.createTextNode(`${usuario.name.split(' ')[0].toLowerCase()} ${usuario.lastname.toLowerCase()}`);
				const starSpan = document.createElement('SPAN');
				starSpan.textContent = usuario.received === "1" ? '*' : '';
				nameParagraph.appendChild(nameText);
				nameParagraph.appendChild(starSpan);

				const documentoParagraph = document.createElement('P');
				documentoParagraph.classList.add('documento');
				const documentText = document.createTextNode(`****${usuario.dni}`);
				documentoParagraph.appendChild(documentText);

				const teamDiv = document.createElement('DIV');
				teamDiv.classList.add('team');

				const teamImgDiv = document.createElement('DIV');
				teamImgDiv.classList.add('team__img');
				const teamImg = document.createElement('IMG');
				teamImg.src = usuario.flag;
				teamImg.alt = 'Team flag';
				teamImgDiv.appendChild(teamImg);

				const teamText = document.createElement('P');
				const teamTextContent = document.createTextNode(usuario.team);
				teamText.appendChild(teamTextContent);

				teamDiv.appendChild(teamImgDiv);
				teamDiv.appendChild(teamText);
				userContainer.appendChild(nameParagraph);
				userContainer.appendChild(documentoParagraph);
				userContainer.appendChild(teamDiv);

				document.body.appendChild(userContainer);
				tablaGanadores?.appendChild(userContainer)
			})
		} else {
			// totalPaginas = 5;
			// Crando contenedor de usuario
			arrayConsulta.filter( (usuario:any) => {
				const userContainer = document.createElement('DIV');
				userContainer.classList.add('tablaGanadores__containerUser');

				const nameParagraph = document.createElement('P');
				nameParagraph.classList.add('name');
				const nameText = document.createTextNode(`${usuario.name.split(' ')[0].toLowerCase()} ${usuario.lastname?.toLowerCase()}`);
				const starSpan = document.createElement('SPAN');
				starSpan.textContent = usuario.received === "1" ? '*' : '';
				nameParagraph.appendChild(nameText);
				nameParagraph.appendChild(starSpan);

				const documentoParagraph = document.createElement('P');
				documentoParagraph.classList.add('documento');
				const documentText = document.createTextNode(usuario.dni);
				documentoParagraph.appendChild(documentText);

				const teamDiv = document.createElement('DIV');
				teamDiv.classList.add('team');

				const teamImgDiv = document.createElement('DIV');
				teamImgDiv.classList.add('team__img');
				const teamImg = document.createElement('IMG');
				teamImg.src = usuario.flag;
				teamImg.alt = 'Team flag';
				teamImgDiv.appendChild(teamImg);

				const teamText = document.createElement('P');
				const teamTextContent = document.createTextNode(usuario.team);
				teamText.appendChild(teamTextContent);

				teamDiv.appendChild(teamImgDiv);
				teamDiv.appendChild(teamText);
				userContainer.appendChild(nameParagraph);
				userContainer.appendChild(documentoParagraph);
				userContainer.appendChild(teamDiv);

				if (usuario.team === teamSelect) {
					tablaGanadores?.appendChild(userContainer);
				}
			})
			if(tablaGanadores?.children.length === 0) {
				const userContainer = document.createElement('P')
				userContainer.classList.add('containerEmpty')
				userContainer.textContent = "No hay equipo seleccionado en ésta pagina"
				tablaGanadores?.appendChild(userContainer)
			}
			
		}

		// Limpiar paginador previo
		cleancontainer(paginadorGanadores)

		// Generar paginador
		printPaginator()

		//agregando final del paginador
		printPaginatorTotal()

		// agregando clase active
		addActiveButon(pagina)

	} catch (error) {
		console.error(error);
	}
	
}

const mySwiperProducts = () => {
  if (document.querySelector('.mySwiperProducts')) {
    const swiperProducts = new Swiper('.mySwiperProducts', {
      modules: [Navigation, Pagination],
				slidesPerView: 3,
        spaceBetween: 20,
				grabCursor: true,
				breakpoints: {
					// when window width is >= 320px
					320: {
						slidesPerView: 1,
						spaceBetween: 20
					},
					// when window width is >= 480px
					678: {
						slidesPerView: 2,
						spaceBetween: 30
					},
					// when window width is >= 640px
					991: {
						slidesPerView: 3,
						spaceBetween: 20
					}
				},
				direction: 'horizontal',
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
				pagination: {
						el: ".swiper-pagination",
						clickable: true,
				},
    })

  }
}

const datalayers = () => {

	// BOTON PARTICIPAR HOME

	let btnQuieroParticipar = document.querySelector("#participar") as any;
  if (btnQuieroParticipar) {
    btnQuieroParticipar.addEventListener("click", (e: any) => {
				fetch('/authenticated')
				.then(res => res.json())
				.then(data => {
					// console.log(data)
					if (data === "NOT_AUTHETICATED") {
						window.drupalLogin();
					} else{
						if (data === "THE_USER_PLAYED") {
							window.location.replace('/temporada-de-grandes/gracias');
						} else if (data === "THE_USER_HAS_NOT_PLAYED") {
							window.location.replace('/zona-de-usuario');
						}
					}
				})


				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push({
					'event': 'GAEvent',
					'event_category': 'Content',
					'event_action': 'Content',
					'event_label': 'Quiero participar',
					'interaction':'true',
					'component_name': 'Quiero participar',
					'element_text': 'Quiero participar'

				})

    });
  }

	// BOTON COMPRAR - HOME

	let btnComprarP = document.querySelectorAll(".btnComprarPdataLayer") as any;
  if (btnComprarP) {
	btnComprarP.forEach(element => {
		element.addEventListener("click", (e: any) => {

	
			// let dataSku = e;

			let parentdiv = e.target.parentNode

			let sku = parentdiv.querySelector('h3').innerHTML


				
		  window.dataLayer.push({
			'event': 'GAEvent',
					'event_category': 'Content',
					'event_action': 'Cntent',
					'event_label': sku ,
					'interaction':'true',
					'component_name': 'Comprar',
					'element_text': 'Comprar'
		  });
	
		});
		
	});
  }

};

const dalayerBuy = () => {
	const buyBeers = document.querySelectorAll('.buyBeer')
	const dataLayer = window.dataLayer;
	buyBeers.forEach((buyBeer : any) => {
	  buyBeer.addEventListener('click', (e: any) => {
		let skubt = buyBeer.dataset.skubutton
		dataLayer.push({
		  'event': 'GAEvent',
		  'event_category': 'Content',
		  'event_action': 'Content', 
		  'event_label': `${skubt}`,
		  'interaction':'true',
		  'component_name': 'Comprar',
		  'element_text': 'Comprar'
		});
	  })
	})
  }


